enum IndexName {
	PropertyId = 'propertyId',
	OrderId = 'orderId',
	UserId = 'userId',
	FileId = 'fileId',
}

export default IndexName;
